import * as React from "react";

import { MessageDescriptor } from "react-intl";
import { Icon, IconSymbol } from "./Icons";
import { WrappedMessage } from "./utils/utils";
import "./styles.scss";

export interface ButtonProps {
  titleDescriptor: MessageDescriptor;
  onClick: () => void;
  iconName?: IconSymbol;
  textBeforeIcon?: boolean;
  disabled?: boolean;
  className?: string;
}

/**
 * Yellow action button used for starting assets, simulations, etc.
 */
export const Button: React.FunctionComponent<ButtonProps> = (props) => {
  const {
    textBeforeIcon,
    iconName,
    titleDescriptor,
    onClick,
    className,
    disabled = false,
  } = props;

  return (
    <button className={`${className}`} onClick={onClick} disabled={disabled}>
      {!textBeforeIcon && iconName && (
        <Icon name={iconName ?? "triangle-right"} />
      )}
      <WrappedMessage message={titleDescriptor} />
      {textBeforeIcon && iconName && (
        <Icon className={"svg-right"} name={iconName ?? "triangle-right"} />
      )}
    </button>
  );
};
